/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Source: sdk.manifest.yml + openapi.json.
 * Regenerate with: pnpm gen
 */

import { createMutationHook } from '../../core/factories/createMutation.js';
import type { SubmitFeedbackResponse, SubmitFeedbackVars } from '../openapi-types.gen.js';

export type { SubmitFeedbackResponse, SubmitFeedbackVars } from '../openapi-types.gen.js';

export const useSubmitFeedback = createMutationHook<SubmitFeedbackVars, SubmitFeedbackResponse, unknown>({
  specName: 'useSubmitFeedback',
  path: '/v1/feedback',
  method: 'POST',
  resolveUrl: (vars: SubmitFeedbackVars) => `/v1/feedback`,
  buildBody: (vars: SubmitFeedbackVars) => ({ type: vars.type, message: vars.message, context: vars.context }),
  parseResponse: (raw: unknown): SubmitFeedbackResponse => raw as SubmitFeedbackResponse,
  
  
  
});
